// extracted by mini-css-extract-plugin
export default {"popup":"SBaux","container":"DQEnm","iconClose":"OcXyV","wrapperImage":"TVBAd","img":"YbaLT","iconPlay":"iP7mP","content":"slHm_","title":"gPGvh","text":"ysx0o"};